// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./MonitorStopIcon.data";

export const MonitorStopIcon = createIcon("MonitorStopIcon", iconNode);
